<template>
  <el-dialog :class="!isdata ?'': 'uploaddise'" :title="Type == 0? $t('All.检验基准表文件'):Type == 1? $t('All.工程图面文件'):Type == 2? $t('All.承认书文件'):Type == 4? $t('All.实验报告'): $t('All.其它文件')"  width="80%" append-to-body :before-close="handleClose" :visible.sync="dialog">
    <el-upload list-type="picture-card" :limit="Type == 3 ? 50: 1" :action="`${$Upload}/api/Newiqc/File_user_upload/`" :data="filedata" :on-success="handsuccess" :file-list="fileList">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="xsimg(file)" :alt="file.name + file.Del">
            <span class="el-upload-list__item-actions" :alt="file.name">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                </span>
                <span v-if="!isdata && file.Del" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                </span>
            </span>
            <p>{{file.name}}</p>
        </div>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </el-upload>
</el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],
      filedata: {
        Number: this.Number,
        Type: this.Type,
        Index: '',
        User: this.$store.state.Login.User,
        Username: this.$store.state.Login.Username,
        Factory: this.$store.state.Login.Factory
      },
      dialog: true
    }
  },
  props: ['Number', 'Type', 'FileList', 'FalseUpload', 'Uphandsuccess', 'isdata'], // 接手psMsg值
  created () {
    this.fileList = this.FileList
  },
  mounted () {
    console.log(this.fileList)
  },
  methods: {
    handleClose (done) {
      this.$confirm(this.$t('All.确认关闭'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(_ => {
          this.FalseUpload()
        })
        .catch(_ => {})
    },
    async handleRemove (file) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        var row = {
          Name: file.name,
          Type: this.Type,
          Number: this.Number
        }
        const { data: res } = await this.$http.post('/api/Newiqc/File_user_del', row)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.fileList.some((item, i) => {
          if (item.name === file.name) {
            this.fileList.splice(i, 1)
          }
        })
        this.$message.success(`${this.$t('All.删除')}${file.name}${this.$t('All.成功')}`)
        this.Uphandsuccess(this.Type, this.fileList, 0)
      } catch (error) {
        this.$message.error(error)
        loadingInstance.close()
      }
    },
    handlePictureCardPreview (file) {
      window.open(file.url, '_blank')
    },
    handleDownload (file) {
      window.open(file.url, '_blank')
    },
    xsimg (val) {
      var index = val.name.lastIndexOf('.')
      const obj = val.name.substring(index + 1, val.name.length)
      const objj = obj.toUpperCase()
      switch (objj) {
        case 'JPEG':
          return val.url
        case 'BMP':
          return val.url
        case 'TIFF':
          return val.url
        case 'GIF':
          return val.url
        case 'PNG':
          return val.url
        case 'JPG':
          return val.url
        case 'PDF':
          return require('@/assets/Img/pdf.jpg')
        case 'XLS':
          return require('@/assets/Img/excle.jpg')
        case 'XLSX':
          return require('@/assets/Img/excle.jpg')
        case 'RAR':
          return require('@/assets/Img/rar.jpeg')
        case 'ZIP':
          return require('@/assets/Img/rar.jpeg')
        default:
          return require('@/assets/Img/nullimg.jpeg')
      }
    },
    async handsuccess (response) {
      const data = {
        name: '',
        url: ''
      }
      if (response.status !== 200) return this.$message.error(this.$t('All.图片上传失败'))
      data.name = response.name
      data.url = this.$Upload + '/' + response.url
      data.Del = true
      this.fileList.splice(0, 0, data)
      this.$message.success(`${this.$t('system.上传')}${response.name}${this.$t('All.成功')}`)
      this.Uphandsuccess(this.Type, this.fileList, 1)
    }
  }
}
</script>
<style lang="less" scoped>
.elemzit {
font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
font-size: 16px;
font-style: normal;
}
</style>
